import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './styles/index.css';
import 'react-photo-view/dist/react-photo-view.css';
import router from './ProviderRouter';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './state/store';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './utils/queryClient';

// ChunkLoadError 전역 핸들러 추가
window.addEventListener('error', event => {
  const error = event.error || event.message;
  const isChunkLoadError =
    (error instanceof Error && error.name === 'ChunkLoadError') ||
    (error instanceof Error && error.message?.includes('Loading chunk')) ||
    (error instanceof Error &&
      error.message?.includes('Failed to fetch dynamically imported module')) ||
    (typeof error === 'string' && error.includes('Loading chunk')) ||
    (typeof error === 'string' &&
      error.includes('Failed to fetch dynamically imported module'));

  if (isChunkLoadError) {
    console.warn(
      'ChunkLoadError detected in global error handler. Reloading page...'
    );
    // ChunkLoadError 발생 시 페이지 새로고침
    event.preventDefault();
    window.location.reload();
  }
});

// Promise rejection에서도 ChunkLoadError 처리
window.addEventListener('unhandledrejection', event => {
  const error = event.reason;
  const isChunkLoadError =
    (error instanceof Error && error.name === 'ChunkLoadError') ||
    (error instanceof Error && error.message?.includes('Loading chunk')) ||
    (error instanceof Error &&
      error.message?.includes('Failed to fetch dynamically imported module')) ||
    (typeof error === 'string' && error.includes('Loading chunk')) ||
    (typeof error === 'string' &&
      error.includes('Failed to fetch dynamically imported module'));

  if (isChunkLoadError) {
    console.warn(
      'ChunkLoadError detected in unhandledrejection. Reloading page...'
    );
    event.preventDefault();
    window.location.reload();
  }
});

// iOS 웹뷰는 <input>에 autocapitalize 속성이 없으면 기본값(sentences)으로 첫 글자를
//  자동 대문자화한다(안드로이드는 이 동작이 없음). 컴포넌트마다 속성을 다는 대신
//  포커스 시점에 전역으로 꺼준다 — 키보드가 뜨기 전(캡처 단계)에 세팅되어야 반영된다.
document.addEventListener(
  'focus',
  event => {
    const el = event.target;
    if (
      (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) &&
      !el.hasAttribute('autocapitalize')
    ) {
      el.setAttribute('autocapitalize', 'off');
    }
  },
  true
);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  //<React.StrictMode>
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </Provider>
  //</React.StrictMode>
);

// Web Vitals 측정을 지연시켜 초기 로딩 속도 개선 (FCP 개선)
// 페이지 로드 완료 후 측정 시작
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(
    () => {
      reportWebVitals();
    },
    { timeout: 3000 }
  );
} else {
  setTimeout(() => {
    reportWebVitals();
  }, 100);
}
